export default {
    CSVNUMBERS: 'csv-numbers',
    NUMBERS: 'numbers',
    /** @type {'/numbers/tpm'} */
    NUMBERS_TPM: '/numbers/tpm',
    NUMBERS_BULK_TEAMS: '/numbers/bulk-operations/microsoft-teams',
};
